class n {
  static syncUrlSearchParams() {
    return this.urlSearchParams = new URLSearchParams(window.location.search), this;
  }
  static getUrlSearchParams() {
    return this.urlSearchParams || this.syncUrlSearchParams(), this.urlSearchParams;
  }
  static getQueryParam(t) {
    return this.getUrlSearchParams().get(t);
  }
  static change(t, { shallow: r = !0, shallowMode: e = "replace" } = {}) {
    return r ? (e === "replace" ? window.history.replaceState(null, "", t) : window.history.pushState(null, "", t), this.syncUrlSearchParams(), this) : (window.location.href = t, this);
  }
  static modify({ url: t = null, domain: r = null, path: e = null, search: a = null, hash: s = null, shallow: i = !0, shallowMode: l = "replace" } = {}) {
    return t || (r = r ?? window.location.origin, e = e ?? window.location.pathname, a === null ? a = window.location.search : a !== "" && !a.startsWith("?") && (a = `?${a}`), s === null ? s = window.location.hash : s !== "" && !s.startsWith("#") && (s = `#${s}`), t = `${r}${e}${a}${s}`), this.change(t, { shallow: i, shallowMode: l }), this;
  }
  static setQueryParams(t) {
    const r = this.getUrlSearchParams();
    for (const [e, a] of Object.entries(t))
      r.set(e, a ?? "");
    return this.modify({
      search: r.toString()
    }), this;
  }
  static setQueryParam(t, r = null) {
    return this.setQueryParams({ [t]: r }), this;
  }
  static deleteQueryParams(t) {
    const r = this.getUrlSearchParams();
    for (const e of t)
      r.delete(e);
    return this.modify({
      search: r.toString()
    }), this;
  }
  static deleteQueryParam(t) {
    return this.deleteQueryParams([t]), this;
  }
  static modifyQueryParams({ set: t, delete: r }) {
    const e = this.getUrlSearchParams();
    if (t)
      for (const [a, s] of Object.entries(t))
        e.set(a, s ?? "");
    if (r)
      for (const a of r)
        e.delete(a);
    return this.modify({
      search: e.toString()
    }), this;
  }
}
n.urlSearchParams = null;
export {
  n as Url
};
//# sourceMappingURL=index.js.map
